export default [
{ "name": "Avon", "country": "GB", "region": "England" },
{ "name": "Bedfordshire", "country": "GB", "region": "England" },
{ "name": "Berkshire", "country": "GB", "region": "England" },
{ "name": "Borders", "country": "GB", "region": "England" },
{ "name": "Bristol", "country": "GB", "region": "England" },
{ "name": "Buckinghamshire", "country": "GB", "region": "England" },
{ "name": "Cambridgeshire", "country": "GB", "region": "England" },
{ "name": "Channel Islands", "country": "GB", "region": "England" },
{ "name": "Cheshire", "country": "GB", "region": "England" },
{ "name": "Cleveland", "country": "GB", "region": "England" },
{ "name": "Cornwall", "country": "GB", "region": "England" },
{ "name": "Cumbria", "country": "GB", "region": "England" },
{ "name": "Derbyshire", "country": "GB", "region": "England" },
{ "name": "Devon", "country": "GB", "region": "England" },
{ "name": "Dorset", "country": "GB", "region": "England" },
{ "name": "Durham", "country": "GB", "region": "England" },
{ "name": "East Riding of Yorkshire", "country": "GB", "region": "England" },
{ "name": "East Sussex", "country": "GB", "region": "England" },
{ "name": "Essex", "country": "GB", "region": "England" },
{ "name": "Gloucestershire", "country": "GB", "region": "England" },
{ "name": "Greater Manchester", "country": "GB", "region": "England" },
{ "name": "Hampshire", "country": "GB", "region": "England" },
{ "name": "Herefordshire", "country": "GB", "region": "England" },
{ "name": "Hertfordshire", "country": "GB", "region": "England" },
{ "name": "Humberside", "country": "GB", "region": "England" },
{ "name": "Isle of Man", "country": "GB", "region": "England" },
{ "name": "Isle of Wight", "country": "GB", "region": "England" },
{ "name": "Isles of Scilly", "country": "GB", "region": "England" },
{ "name": "Kent", "country": "GB", "region": "England" },
{ "name": "Lancashire", "country": "GB", "region": "England" },
{ "name": "Leicestershire", "country": "GB", "region": "England" },
{ "name": "Lincolnshire", "country": "GB", "region": "England" },
{ "name": "London", "country": "GB", "region": "England" },
{ "name": "Merseyside", "country": "GB", "region": "England" },
{ "name": "Middlesex", "country": "GB", "region": "England" },
{ "name": "Norfolk", "country": "GB", "region": "England" },
{ "name": "North Yorkshire", "country": "GB", "region": "England" },
{ "name": "Northamptonshire", "country": "GB", "region": "England" },
{ "name": "Northumberland", "country": "GB", "region": "England" },
{ "name": "Nottinghamshire", "country": "GB", "region": "England" },
{ "name": "Oxfordshire", "country": "GB", "region": "England" },
{ "name": "Rutland", "country": "GB", "region": "England" },
{ "name": "Shropshire", "country": "GB", "region": "England" },
{ "name": "Somerset", "country": "GB", "region": "England" },
{ "name": "South Yorkshire", "country": "GB", "region": "England" },
{ "name": "Staffordshire", "country": "GB", "region": "England" },
{ "name": "Suffolk", "country": "GB", "region": "England" },
{ "name": "Surrey", "country": "GB", "region": "England" },
{ "name": "Tyne and Wear", "country": "GB", "region": "England" },
{ "name": "Warwickshire", "country": "GB", "region": "England" },
{ "name": "West Midlands", "country": "GB", "region": "England" },
{ "name": "West Sussex", "country": "GB", "region": "England" },
{ "name": "West Yorkshire", "country": "GB", "region": "England" },
{ "name": "Wiltshire", "country": "GB", "region": "England" },
{ "name": "Worcestershire", "country": "GB", "region": "England" },

{ "name": "Antrim", "country": "GB", "region": "Northern Ireland" },
{ "name": "Down", "country": "GB", "region": "Northern Ireland" },
{ "name": "Fermanagh", "country": "GB", "region": "Northern Ireland" },
{ "name": "Londonderry", "country": "GB", "region": "Northern Ireland" },
{ "name": "Tyrone", "country": "GB", "region": "Northern Ireland" },

{ "name": "Aberdeen City", "country": "GB", "region": "Scotland" },
{ "name": "Aberdeenshire", "country": "GB", "region": "Scotland" },
{ "name": "Angus", "country": "GB", "region": "Scotland" },
{ "name": "Argyll and Bute", "country": "GB", "region": "Scotland" },
{ "name": "Armagh", "country": "GB", "region": "Scotland" },
{ "name": "Carmarthenshire", "country": "GB", "region": "Scotland" },
{ "name": "Clackmannan", "country": "GB", "region": "Scotland" },
{ "name": "Dumfries and Galloway", "country": "GB", "region": "Scotland" },
{ "name": "East Ayrshire", "country": "GB", "region": "Scotland" },
{ "name": "East Dunbartonshire", "country": "GB", "region": "Scotland" },
{ "name": "East Lothian", "country": "GB", "region": "Scotland" },
{ "name": "East Renfrewshire", "country": "GB", "region": "Scotland" },
{ "name": "Edinburgh City", "country": "GB", "region": "Scotland" },
{ "name": "Falkirk", "country": "GB", "region": "Scotland" },
{ "name": "Fife", "country": "GB", "region": "Scotland" },
{ "name": "Glasgow", "country": "GB", "region": "Scotland" },
{ "name": "Highland", "country": "GB", "region": "Scotland" },
{ "name": "Inverclyde", "country": "GB", "region": "Scotland" },
{ "name": "Midlothian", "country": "GB", "region": "Scotland" },
{ "name": "Moray", "country": "GB", "region": "Scotland" },
{ "name": "North Ayrshire", "country": "GB", "region": "Scotland" },
{ "name": "North Lanarkshire", "country": "GB", "region": "Scotland" },
{ "name": "Orkney", "country": "GB", "region": "Scotland" },
{ "name": "Perthshire and Kinross", "country": "GB", "region": "Scotland" },
{ "name": "Renfrewshire", "country": "GB", "region": "Scotland" },
{ "name": "Roxburghshire", "country": "GB", "region": "Scotland" },
{ "name": "Shetland", "country": "GB", "region": "Scotland" },
{ "name": "South Ayrshire", "country": "GB", "region": "Scotland" },
{ "name": "South Lanarkshire", "country": "GB", "region": "Scotland" },
{ "name": "Stirling", "country": "GB", "region": "Scotland" },
{ "name": "West Dunbartonshire", "country": "GB", "region": "Scotland" },
{ "name": "West Lothian", "country": "GB", "region": "Scotland" },
{ "name": "Western Isles", "country": "GB", "region": "Scotland" },

{ "name": "Blaenau Gwent", "country": "GB", "region": "Wales" },
{ "name": "Bridgend", "country": "GB", "region": "Wales" },
{ "name": "Caerphilly", "country": "GB", "region": "Wales" },
{ "name": "Cardiff", "country": "GB", "region": "Wales" },
{ "name": "Ceredigion", "country": "GB", "region": "Wales" },
{ "name": "Conwy", "country": "GB", "region": "Wales" },
{ "name": "Denbighshire", "country": "GB", "region": "Wales" },
{ "name": "Flintshire", "country": "GB", "region": "Wales" },
{ "name": "Gwynedd", "country": "GB", "region": "Wales" },
{ "name": "Isle of Anglesey", "country": "GB", "region": "Wales" },
{ "name": "Merthyr Tydfil", "country": "GB", "region": "Wales" },
{ "name": "Monmouthshire", "country": "GB", "region": "Wales" },
{ "name": "Neath Port Talbot", "country": "GB", "region": "Wales" },
{ "name": "Newport", "country": "GB", "region": "Wales" },
{ "name": "Pembrokeshire", "country": "GB", "region": "Wales" },
{ "name": "Powys", "country": "GB", "region": "Wales" },
{ "name": "Rhondda Cynon Taff", "country": "GB", "region": "Wales" },
{ "name": "Swansea", "country": "GB", "region": "Wales" },
{ "name": "The Vale of Glamorgan", "country": "GB", "region": "Wales" },
{ "name": "Torfaen", "country": "GB", "region": "Wales" },
{ "name": "Wrexham", "country": "GB", "region": "Wales" }
]
